<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="UserProfile" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { UserProfileProps } from './UserProfile.ts';
import UserProfile from './UserProfile.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-user-profile';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<UserProfileProps>();
const changableProps = useChangableProps(componentName, props);

</script>
